import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { composeUrlFromUrlParams } from '../UrlUtils';
import { history } from '../../modules/App/AppContainer';


class MenuTabItem extends Component {

  constructor(props) {
    super(props);
    this.changeRoute = this.changeRoute.bind(this);
  }

  changeRoute() {
    const url = composeUrlFromUrlParams(this.props.urlParams, this.props.paramType, this.props.paramValue);
    history.push(url);
  }

  render() {
    return (
      <div className="label-wrapper">
        <label className={`${!this.props.checked ? 'cursor--pointer' : null} mt-menu-tab-item block mb-`}>
          <div onClick={this.changeRoute}>
            <div className="mt-checkbox-container" >
            {this.props.checked ?
              <div className="mt-checkbox-checked"></div>
            : null}
            </div>
            <span className={`${this.props.checked ? 'mt-checkbox-label-checked' : 'mt-checkbox-label'} ml-`}>{this.props.label}</span>
            {this.props.checked ?
              <div className="mt-menu-tab-item-description">
                {this.props.description}
              </div>
            : null}
          </div>
        </label>
      </div>
    );
  }
}

MenuTabItem.propTypes = {
  paramType: PropTypes.string,
  paramValue: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  inputType: PropTypes.string,
  imgSrc: PropTypes.string,
};

export default connect(state => state.AppState)(MenuTabItem);



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/Menu/MenuTabItem.js
 **/